<template>
  <div>
    <b-alert
      :show="dismissCountDown"
      dismissible
      fade
      variant="primary"
      @dismissed="dismissCountDown=0"
      @dismiss-count-down="countDownChanged"
      >
        {{allertMessage}}
    </b-alert>
    <preloader v-if="showPreloader"></preloader>
    <camera v-if="showCamera"
      :imagesList="photoType"
      v-on:closecamera="closeCamera">
    </camera>
      <div class="container accident-report">
        <h1 class="text-center mb-1 sm">
          <base-button v-on:click="goHome" size='md' class="mt-1 back-button" type="primary">Back</base-button>
          Accident report
        </h1>
        <div class="panel panel-default">
        <div class="panel-body">
          <form @submit.prevent>
            <h5 class="info-header text-left mb-3">Information</h5>
            <p>First take a picture of the license plate of the other vehicle</p>
            <div class="form-group text-left">
              <label><strong>Picture of the licence plate</strong></label>
              <div>
                <a v-on:click='takePicture(["accident", "licencePlatePictures"])' class="link"><i class="fa fa-camera" aria-hidden="true"></i> Tap to take picture</a>
                <badge type="primary" class="pull-right"><i class="fa fa-paperclip" aria-hidden="true"></i> {{accident.licencePlatePictures.length}}</badge>
              </div>
            </div>
            <div class="form-group text-left">
              <label><strong>Driver Name</strong></label>
              <input placeholder=""
                    class="form-control"
                    v-model="driverInfoName"
                    type="text">
            </div>
            <div class="form-group text-left">
              <label><strong>Driver's License</strong></label>
              <input placeholder=""
                    class="form-control"
                    v-model="driverInfo.license"
                    type="text">
            </div>
            <div class="form-group text-left">
              <label><strong>Driver's Age</strong></label>
              <input placeholder=""
                    class="form-control"
                    v-model="driverInfo.age"
                    type="text">
            </div>
            <div class="form-group text-left">
              <label><strong>Driver's State</strong></label>
              <input placeholder=""
                    class="form-control"
                    v-model="driverInfoState"
                    type="text">
            </div>
            <div class="form-group text-left">
              <label><strong>Vehicle</strong></label>
              <input placeholder="Year"
                    class="form-control"
                    v-model="driverInfoVehicleYear"
                    type="text">
            </div>
            <div class="form-group text-left">
              <input placeholder="Make"
                    class="form-control"
                    v-model="driverInfoVehicleMake"
                    type="text">
            </div>
            <div class="form-group text-left">
              <input placeholder="Model"
                    class="form-control"
                    v-model="driverInfoVehicleModel"
                    type="text">
            </div>
            <div class="form-group text-left">
              <input placeholder="Unit No:"
                    class="form-control"
                    v-model="driverInfo.vehicleUnit"
                    type="text">
            </div>
            <div class="form-group text-left">
              <input placeholder="License Plate"
                    class="form-control"
                    v-model="driverInfoVehicleLicensePlate"
                    type="text">
            </div>
            <div class="form-group text-left">
              <input placeholder="State"
                    class="form-control"
                    v-model="driverInfoVehicleState"
                    type="text">
            </div>
            <div class="form-group text-left">
              <label><strong>Division</strong></label>
              <input placeholder=""
                    class="form-control"
                    v-model="driverInfoDivision"
                    type="text">
            </div>
            <div class="form-group text-left">
              <label><strong>Job Title</strong></label>
              <input placeholder=""
                    class="form-control"
                    v-model="driverInfoJobTitle"
                    type="text">
            </div>
            <div class="form-group text-left">
              <label><strong>Policy Number</strong></label>
              <input placeholder=""
                    class="form-control"
                    v-model="driverInfo.policyNumber"
                    type="text">
            </div>
            <h5 class="info-header text-left mb-3">Accident information</h5>
            <div class="row">
              <div class="col-sm">
                <div class="form-group text-left">
                  <flat-pickr
                    class="form-control"
                    placeholder="Date"
                    :config="dateConfig"
                    v-model="accident.date">
                  </flat-pickr>
                </div>
              </div>
              <div class="col-sm">
                <div class="form-group text-left">
                  <flat-pickr
                    :config="timeConfig"
                    class="form-control"
                    v-model="accident.time">
                  </flat-pickr>
                </div>
              </div>
            </div>
            <div class="form-group text-left">
              <label >Location</label>
              <textarea class="form-control" v-model="accident.locationPlace" rows="3"></textarea>
            </div>
            <div class="form-group">
              <label>Weather</label>
              <multiselect
                v-model="accident.weather"
                tag-placeholder="Add this as new tag"
                placeholder=""
                :options="weatherOptions"
                :multiple="true"
                :taggable="true"
                @tag="addTag($event, [weatherOptions, accident.weather])"></multiselect>
            </div>
            <div class="form-group">
              <label>Area</label>
              <multiselect
                v-model="accident.area"
                tag-placeholder="Add this as new tag"
                placeholder=""
                :options="areaOptions"
                :multiple="true"
                :taggable="true"
                @tag="addTag($event, [areaOptions, accident.area])"></multiselect>
            </div>
            <div class="form-group">
              <label>Pavement</label>
              <multiselect
                v-model="accident.pavement"
                tag-placeholder="Add this as new tag"
                placeholder=""
                :options="pavementOptions"
                :multiple="true"
                :taggable="true"
                @tag="addTag($event, [pavementOptions, accident.pavement])"></multiselect>
            </div>
            <div class="form-group">
              <label>Condition</label>
              <multiselect
                v-model="accident.condition"
                tag-placeholder="Add this as new tag"
                placeholder=""
                :options="conditionOptions"
                :multiple="true"
                :taggable="true"
                @tag="addTag($event, [conditionOptions, accident.condition])"></multiselect>
            </div>
            <div class="form-group">
              <label>Seat belts</label>
              <multiselect
                v-model="accident.seatbelts"
                tag-placeholder="Add this as new tag"
                placeholder=""
                :options="seatbeltsOptions"></multiselect>
            </div>
            <div class="form-group">
              <label>Direction Yours</label>
              <multiselect
                v-model="accident.directionYours"
                tag-placeholder="Add this as new tag"
                placeholder=""
                :options="directionOptions"></multiselect>
            </div>
            <div class="form-group">
              <label>Direction Other</label>
              <multiselect
                v-model="accident.directionOther"
                tag-placeholder="Add this as new tag"
                placeholder=""
                :options="directionOptions"></multiselect>
            </div>
            <div class="form-group">
              <label><strong>Speed</strong></label>
              <div class="row">
                <div class="col-sm">
                  <base-input class="mb-3"
                        placeholder="Yours posted"
                        name='boxesNumber'
                        v-model="accident.speedYoursPosted"
                        type="text"
                        addonRightIcon=''>
                  </base-input>
                </div>
                <div class="col-sm">
                  <base-input class="mb-3"
                        placeholder="Yours actual"
                        name='boxesNumber'
                        v-model="accident.speedYoursActual"
                        type="text"
                        addonRightIcon=''>
                  </base-input>
                </div>
              </div>
              <div class="row">
                <div class="col-sm">
                  <base-input class="mb-3"
                        placeholder="Other posted"
                        name='boxesNumber'
                        v-model="accident.speedOtherPosted"
                        type="text"
                        addonRightIcon=''>
                  </base-input>
                </div>
                <div class="col-sm">
                  <base-input class="mb-3"
                        placeholder="Other actual"
                        name='boxesNumber'
                        v-model="accident.speedOtherActual"
                        type="text"
                        addonRightIcon=''>
                  </base-input>
                </div>
              </div>
            </div>
            <div class="form-group">
              <label><strong>Traffic control</strong></label>
              <multiselect
                v-model="accident.trafficcontrol"
                tag-placeholder="Add this as new tag"
                placeholder=""
                :options="trafficcontrolOptions"
                :multiple="true"
                :taggable="true"
                @tag="addTag($event, [trafficcontrolOptions, accident.trafficcontrol])"></multiselect>
            </div>
            <div class="form-group">
              <label>Air Bag Inflate</label>
              <multiselect
                v-model="accident.airbagInflate"
                tag-placeholder="Add this as new tag"
                placeholder=""
                :options="airbagInflateOptions"></multiselect>
            </div>
            <h5 class="info-header text-left mb-3">Accident Description</h5>
            <div class="form-group text-left">
              <label >Briefly tell how the accident happend. Indicate movement of involved vehicles when hazard was first noticed, warning or evasive action taken and length and position of any skid marks</label>
              <textarea class="form-control" v-model="accident.description" rows="3"></textarea>
            </div>
            <h5 class="info-header text-left mb-3">Property Damage - Describe nature of damage</h5>
            <div class="form-group text-left">
              <label for="deliveryProduct"><strong>CTM Driver</strong></label>
              <input type="text"
                    class="form-control"
                    placeholder="Injury"
                    v-model="accident.ctmDriverInjury">
            </div>
            <div v-for="(passenger,index) in accident.ctmPassengers" :key="index">
              <div class="form-group text-left">
                <base-button size="sm" @click="removeElement(index, 'ctmPassengers')" class="pull-right" v-if="accident.ctmPassengers.length > 1" outline type="danger">Remove</base-button>
                <label><strong>CTM Passenger</strong></label>
                <input placeholder="Name"
                      class="form-control"
                      v-model="passenger.name"
                      type="text">
              </div>
              <div class="form-group text-left">
                <input placeholder="Adress"
                      class="form-control"
                      v-model="passenger.address"
                      type="text">
              </div>
              <div class="form-group text-left">
                <input placeholder="Injury"
                      class="form-control"
                      v-model="passenger.injury"
                      type="text">
              </div>
            </div>
            <a @click="addCtmPassenger" style="cursor:pointer;">Add ctm passenger</a>
            <div v-for="(driver,index) in accident.driverOtherVehicle" :key="`driver-${index}`">
              <div class="form-group text-left">
                <base-button size="sm" @click="removeElement(index, 'driverOtherVehicle')" class="pull-right" v-if="accident.driverOtherVehicle.length > 1" outline type="danger">Remove</base-button>
                <label><strong>Driver other vehicle</strong></label>
                <input placeholder="Name"
                      class="form-control"
                      v-model="driver.name"
                      type="text">
              </div>
              <div class="form-group text-left">
                <input placeholder="Adress"
                      class="form-control"
                      v-model="driver.address"
                      type="text">
              </div>
              <div class="form-group text-left">
                <input placeholder="Injury"
                      class="form-control"
                      v-model="driver.injury"
                      type="text">
              </div>
            </div>
            <a @click="addDriverOtherVehicle" style="cursor:pointer;">Add other Driver</a>
            <div v-for="(passenger,index) in accident.passengerOtherVehicle" :key="`pass-${index}`">
              <div class="form-group text-left">
                <base-button size="sm" @click="removeElement(index, 'passengerOtherVehicle')" class="pull-right" v-if="accident.passengerOtherVehicle.length > 1" outline type="danger">Remove</base-button>
                <label><strong>Passenger other vehicle, pedestrian</strong></label>
                <input placeholder="Name"
                      class="form-control"
                      v-model="passenger.name"
                      type="text">
              </div>
              <div class="form-group text-left">
                <input placeholder="Adress"
                      class="form-control"
                      v-model="passenger.address"
                      type="text">
              </div>
              <div class="form-group text-left">
                <input placeholder="Injury"
                      class="form-control"
                      v-model="passenger.injury"
                      type="text">
              </div>
            </div>
            <a @click="addPassengerOtherVehicle" style="cursor:pointer;">Add other passenger</a>
            <div class="form-group text-left">
              <label><strong>Location where injured individuals taken</strong></label>
              <textarea class="form-control"  v-model="accident.locationInjuredIndividualsTaken" rows="3"></textarea>
            </div>
            <h5 class="info-header text-left mb-3">Property damage - describe nature of damage</h5>
            <div class="form-group text-left">
              <label><strong>CTM vehicle</strong> </label>
              <textarea class="form-control"  v-model="accident.propertyDamageCtmVehicle" rows="3"></textarea>
            </div>
            <div class="form-group text-left">
              <label><strong>Property other than vehicle</strong> </label>
              <textarea class="form-control"  v-model="accident.propertyDamageOtherThanVehicleName" rows="3"></textarea>
            </div>
            <div class="form-group text-left">
              <input placeholder="Owner"
                      class="form-control"
                      v-model="accident.propertyDamageOtherThanVehicleOwner"
                      type="text">
            </div>
            <div class="form-group text-left">
              <input placeholder="Phone"
                      class="form-control"
                      v-model="accident.propertyDamageOtherThanVehiclePhone"
                      type="text">
            </div>
            <div class="form-group text-left">
              <label><strong>Other vehicle</strong> </label>
              <textarea class="form-control" v-model="accident.propertyDamageOtherVehicleVehicle" rows="3"></textarea>
            </div>
            <div class="form-group text-left">
              <input placeholder="Owner"
                      class="form-control"
                      v-model="accident.propertyDamageOtherVehicleOwner"
                      type="text">
            </div>
            <div class="form-group text-left">
              <input placeholder="Driver"
                      class="form-control"
                      v-model="accident.propertyDamageOtherVehicleDriver"
                      type="text">
            </div>
            <div class="form-group text-left">
              <input placeholder="Phone"
                      class="form-control"
                      v-model="accident.propertyDamageOtherVehiclePhone"
                      type="text">
            </div>
            <div class="form-group text-left">
              <input placeholder="Phone"
                      class="form-control"
                      v-model="accident.propertyDamageOtherVehiclePhoneSecond"
                      type="text">
            </div>
            <div class="form-group text-left">
              <input placeholder="Vehicle make"
                      class="form-control"
                      v-model="accident.propertyDamageOtherVehicleMake"
                      type="text">
            </div>
            <div class="form-group text-left">
              <input placeholder="License #"
                      class="form-control"
                      v-model="accident.propertyDamageOtherVehicleLicense"
                      type="text">
            </div>
            <div class="form-group text-left">
              <input placeholder="Insurance Company"
                      class="form-control"
                      v-model="accident.propertyDamageOtherVehicleInsuranceCompany"
                      type="text">
            </div>
            <div class="form-group text-left">
              <input placeholder="Policy Number"
                      class="form-control"
                      v-model="accident.propertyDamageOtherVehiclePolicyNumber"
                      type="text">
            </div>
            <h5 class="info-header text-left mb-3">Police officer assisting</h5>
            <div class="form-group text-left">
              <input placeholder="Name"
                      class="form-control"
                      v-model="accident.policeOfficerAssistingName"
                      type="text">
            </div>
            <div class="form-group text-left">
              <input placeholder="Headquarters"
                      class="form-control"
                      v-model="accident.policeOfficerAssistingHeadquarters"
                      type="text">
            </div>
            <div class="form-group text-left">
              <input placeholder="Badge #"
                      class="form-control"
                      v-model="accident.policeOfficerAssistingBadge"
                      type="text">
            </div>
            <div class="form-group text-left">
              <multiselect
                v-model="accident.policeOfficerAssistingReportMade"
                tag-placeholder="Add this as new tag"
                placeholder="Police report made?"
                :options="['Yes', 'No']"></multiselect>
            </div>
            <div class="form-group text-left">
              <input placeholder="Citations issued"
                      class="form-control"
                      v-model="accident.policeOfficerCitationsIssued"
                      type="text">
            </div>
            <h5 class="info-header text-left mb-3">Witnesses</h5>
            <div v-for="(witness,index) in accident.witnesses" :key="`witness-${index}`">
              <div v-if="accident.witnesses.length > 1" class="form-group text-left">
                <base-button size="sm" @click="removeElement(index, 'witnesses')" class="pull-right" outline type="danger">Remove</base-button>
              </div>
              <div class="form-group text-left">
                <input placeholder="Name"
                      class="form-control"
                      v-model="witness.name"
                      type="text">
              </div>
              <div class="form-group text-left">
                <input placeholder="Address"
                      class="form-control"
                      v-model="witness.address"
                      type="text">
              </div>
              <div class="form-group text-left">
                <input placeholder="Phone"
                      class="form-control"
                      v-model="witness.phone"
                      type="text">
              </div>
            </div>
            <a @click="addWitness" style="cursor:pointer;">Add witnesses</a>
            <div class="form-group text-left">
              <label >Picture</label>
              <div>
                <a v-on:click='takePicture(["accident", "images"])' class="link"><i class="fa fa-camera" aria-hidden="true"></i> Tap to take picture</a>
                <badge type="primary" class="pull-right"><i class="fa fa-paperclip" aria-hidden="true"></i> {{accident.images.length}}</badge>
              </div>
            </div>
            <div class="text-center">
              <base-button type="primary" @click="accidentReportSend" size='md' class="my-4">Submit</base-button>
            </div>
          </form>
        </div>
      </div>
    </div>
  </div>
</template>
<script>

import flatPickr from 'vue-flatpickr-component'
import 'flatpickr/dist/flatpickr.css'
import Multiselect from 'vue-multiselect'
import camera from './../../components/Camera'
import jobActionFormMixin from './../mixins/jobActionFormMixin'
import alertMixin from './../mixins/alertMixin'
import errorStatusMixin from './../mixins/errorStatusMixin'
import driverInfoMixin from './../mixins/driverInfoMixin'

export default {
  data () {
    return {
      showCamera: false,
      showPreloader: false,
      visible: true,
      weatherOptions: ['Clear', 'Sleeting', 'Raining', 'Dust/Smoke/Fog', 'SnowingHigh', 'WindFog'],
      areaOptions: ['Residential', 'Commercial', 'Rural'],
      pavementOptions: ['Asphalt', 'Steel', 'Concrete', 'Wood', 'Gravel/Dirt', 'Brick/Stone'],
      conditionOptions: ['Dry', 'Wet', 'Slippery', 'Pot Holes'],
      seatbeltsOptions: ['Used', 'Not Used'],
      directionOptions: ['W', 'E', 'S', 'N'],
      trafficcontrolOptions: ['Stop Sign - 1 Way', 'Stop Sign - 2 Way', 'Stop Sign - 3 Way', 'Stop Sign - 4 Way', 'Yield', 'Police/Flag Person', 'Stoplights', 'Railroad', 'Uncontrolled Intersection'],
      airbagInflateOptions: ['Yes', 'No', 'N/A'],
      dateConfig: {
        dateFormat: 'Y-m-d'
      },
      timeConfig: {
        enableTime: true,
        noCalendar: true,
        dateFormat: 'H:i',
        altInput: true,
        altFormat: 'h:i K',
        time_24hr: true,
        defaultHour: 12,
        defaultMinute: 0
      },
      driverInfo: {
        name: '',
        license: '',
        age: '',
        state: '',
        vehicleYear: '',
        vehicleMake: '',
        vehicleModel: '',
        vehicleUnit: '',
        vehicleLicensePlate: '',
        vehicleState: '',
        division: '',
        jobTitle: '',
        policyNumber: ''
      },
      value: [],
      accident: {
        licencePlatePictures: [],
        images: [],
        date: this.$moment().format('YYYY-M-D'),
        time: '12:00',
        locationPlace: '',
        weather: [],
        area: [],
        pavement: [],
        condition: [],
        seatbelts: [],
        directionYours: '',
        directionOther: '',
        speedYoursPosted: '',
        speedYoursActual: '',
        speedOtherPosted: '',
        speedOtherActual: '',
        trafficcontrol: [],
        airbagInflate: [],
        description: '',
        ctmDriverInjury: '',
        ctmPassengers: [{
          name: '',
          address: '',
          injury: ''
        }],
        driverOtherVehicle: [{
          name: '',
          address: '',
          injury: ''
        }],
        passengerOtherVehicle: [{
          name: '',
          address: '',
          injury: ''
        }],
        locationInjuredIndividualsTaken: '',
        propertyDamageCtmVehicle: '',
        propertyDamageOtherThanVehicleName: '',
        propertyDamageOtherThanVehicleOwner: '',
        propertyDamageOtherThanVehiclePhone: '',
        propertyDamageOtherVehicleVehicle: '',
        propertyDamageOtherVehicleOwner: '',
        propertyDamageOtherVehicleDriver: '',
        propertyDamageOtherVehiclePhone: '',
        propertyDamageOtherVehiclePhoneSecond: '',
        propertyDamageOtherVehicleMake: '',
        propertyDamageOtherVehicleLicense: '',
        propertyDamageOtherVehicleInsuranceCompany: '',
        propertyDamageOtherVehiclePolicyNumber: '',
        policeOfficerAssistingName: '',
        policeOfficerAssistingHeadquarters: '',
        policeOfficerAssistingBadge: '',
        policeOfficerAssistingReportMade: '',
        policeOfficerCitationsIssued: '',
        witnesses: [
          {
            name: '',
            address: '',
            phone: ''
          }
        ]
      }
    }
  },
  mounted () {
    if (this.isOnline) this.getDriverInfo()
  },
  computed: {
    driverInfoName: {
      get () { return this.$store.state.driver.name },
      set (value) { this.$store.commit('updateDriverInfo', { 'name': value }) }
    },
    driverInfoState: {
      get () { return this.$store.state.driver.state },
      set (value) { this.$store.commit('updateDriverInfo', { 'state': value }) }
    },
    driverInfoVehicleYear: {
      get () { return this.$store.state.driver.year },
      set (value) { this.$store.commit('updateDriverInfo', { 'year': value }) }
    },
    driverInfoVehicleMake: {
      get () { return this.$store.state.driver.make },
      set (value) { this.$store.commit('updateDriverInfo', { 'make': value }) }
    },
    driverInfoVehicleModel: {
      get () { return this.$store.state.driver.model },
      set (value) { this.$store.commit('updateDriverInfo', { 'model': value }) }
    },
    driverInfoVehicleLicensePlate: {
      get () { return this.$store.state.driver.licensePlate },
      set (value) { this.$store.commit('updateDriverInfo', { 'licensePlate': value }) }
    },
    driverInfoVehicleState: {
      get () { return this.$store.state.driver.vehicleLicenseState },
      set (value) { this.$store.commit('updateDriverInfo', { 'vehicleLicenseState': value }) }
    },
    driverInfoDivision: {
      get () { return this.$store.state.driver.division },
      set (value) { this.$store.commit('updateDriverInfo', { 'division': value }) }
    },
    driverInfoJobTitle: {
      get () { return this.$store.state.driver.jobTitle },
      set (value) { this.$store.commit('updateDriverInfo', { 'jobTitle': value }) }
    },
    driverInfoVehicleId: {
      get () { return this.$store.state.driver.vehicleId },
      set (value) { this.$store.commit('updateDriverInfo', { 'vehicleId': value }) }
    }
  },
  methods: {
    updateDriverInformation () {
      this.driverInfo.name = this.driverInfoName
      this.driverInfo.state = this.driverInfoState
      this.driverInfo.vehicleYear = this.driverInfoVehicleYear
      this.driverInfo.vehicleMake = this.driverInfoVehicleMake
      this.driverInfo.vehicleModel = this.driverInfoVehicleModel
      this.driverInfo.vehicleLicensePlate = this.driverInfoVehicleLicensePlate
      this.driverInfo.vehicleState = this.driverInfoVehicleState
      this.driverInfo.division = this.driverInfoDivision
      this.driverInfo.jobTitle = this.driverInfoJobTitle
    },
    goHomeWithDelay () {
      let self = this
      setTimeout(function () {
        self.goHome()
      }, 2000)
    },
    goHome () {
      this.$router.push('/')
    },
    async accidentReportSend () {
      this.showPreloader = true
      this.updateDriverInformation()
      let images = await this.getImagesFromIndexedDb(this.accident.images)
      let licencePlatePictures = await this.getImagesFromIndexedDb(this.accident.licencePlatePictures)
      let obj = Object.assign(this.driverInfo, this.accident)
      obj.images = images
      obj.licencePlatePictures = licencePlatePictures
      this.$store.dispatch('sendAccidentInfo', obj)
        .then(response => {
          if (response) {
            this.showAlert(3, 'Data has been uploaded to server successfully')
            this.showPreloader = false
            this.goHomeWithDelay()
          }
        })
        .catch(err => {
          this.showPreloader = false
          if (!this.errorStatusAvaible(err) && this.isOnline) {
            return this.showAlert(4, 'The request timeout exceeded. The data has been saved and uploaded later')
          }
          console.log(err.response)
          if (this.isOnline) this.showAlert(5, err.response.data.result.message)
          if (this.isOffline) {
            this.showAlert(2, 'You are offline. The data has been saved and uploaded when online')
            this.goHomeWithDelay()
          }
        })
    },
    // Options is array, where first arg is options variable, second is value
    addTag (newTag, options) {
      const tag = newTag
      options[0].push(tag)
      options[1].push(tag)
    },
    addCtmPassenger () {
      this.accident.ctmPassengers.push({
        name: '',
        address: '',
        injury: ''
      })
    },
    addDriverOtherVehicle () {
      this.accident.driverOtherVehicle.push({
        name: '',
        address: '',
        injury: ''
      })
    },
    addPassengerOtherVehicle () {
      this.accident.passengerOtherVehicle.push({
        name: '',
        address: '',
        injury: ''
      })
    },
    addPropertyDamageOtherThanVehicle () {
      this.accident.propertyDamageOtherThanVehicle.push({
        propertyName: '',
        owner: '',
        phone: ''
      })
    },
    addOtherDamageVehicle () {
      this.accident.propertyDamageOtherVehicle.push({
        vehicle: '',
        owner: '',
        phone: '',
        phoneSecond: '',
        vehicleMake: '',
        license: '',
        insuranceCompany: '',
        policyNumber: ''
      })
    },
    addWitness () {
      this.accident.witnesses.push({
        name: '',
        address: '',
        phone: ''
      })
    },
    removeElement (index, field) {
      this.accident[field].splice(index, 1)
    },
    closeCamera (data) {
      this.showCamera = false
      this[data[1][0]][data[1][1]] = data[0]
      this.removeClassFromBody()
    }
  },
  components: {
    flatPickr,
    Multiselect,
    camera
  },
  mixins: [jobActionFormMixin, alertMixin, errorStatusMixin, driverInfoMixin]
}
</script>
<style src="vue-multiselect/dist/vue-multiselect.min.css"></style>
<style>
  .info-header {
    padding-top: 10px;
    margin-top: 25px;
    border-top: 1px solid #8898aa;
  }
  .info-header:first-child {
    margin-top: 0;
  }
</style>
